import React from 'react'

const PhotoIconSvg = ({ fillColor }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z" stroke={fillColor} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.49992 9.16683C8.42039 9.16683 9.16659 8.42064 9.16659 7.50016C9.16659 6.57969 8.42039 5.8335 7.49992 5.8335C6.57944 5.8335 5.83325 6.57969 5.83325 7.50016C5.83325 8.42064 6.57944 9.16683 7.49992 9.16683Z" stroke={fillColor} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5 12.5001L14.9283 9.92841C14.6158 9.61595 14.1919 9.44043 13.75 9.44043C13.3081 9.44043 12.8842 9.61595 12.5717 9.92841L5 17.5001" stroke={fillColor} stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default PhotoIconSvg;